import { keepPreviousData, useQuery } from "@tanstack/react-query";
import moment from "moment";
import ReactPaginate from "react-paginate";
import { useState, useEffect } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";

import Sidebar from "../sidebar";
import {
  downloadOrderExcel,
  downloadOrderXML,
  getOrders,
} from "./orders-section.service";

export default function OrdersSection() {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const pageParam = queryParams.get("page");
  const [currentPage, setCurrentPage] = useState(
    pageParam ? parseInt(pageParam) : 1
  );

  useEffect(() => {
    if (pageParam) {
      setCurrentPage(parseInt(pageParam));
    }
  }, [pageParam]);

  const {
    isPending,
    isError,
    data: response,
    error,
  } = useQuery({
    queryKey: ["admin-orders", currentPage],
    queryFn: () => getOrders({ page: currentPage }),
    placeholderData: keepPreviousData,
  });

  const handlePageChange = (selectedItem: { selected: number }) => {
    const newPage = selectedItem.selected + 1;
    setCurrentPage(newPage);
    navigate(`?page=${newPage}`);
  };

  const handleDownloadExcel = (orderId: string) => {
    downloadOrderExcel(orderId).then((response: any) => {
      const data = new Uint8Array(response.data.data);
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      const date = moment().format("DD-MM-YYYY HH:mm");
      link.setAttribute("download", `order_${date}.xlsx`);
      document.body.appendChild(link);
      link.click();
    });
  };

  const handleDownloadXML = (orderId: string) => {
    downloadOrderXML(orderId).then((response: any) => {
      const data = new Uint8Array(response.data.data);
      const url = window.URL.createObjectURL(new Blob([data]));
      const link = document.createElement("a");
      link.href = url;
      const date = moment().format("DD-MM-YYYY HH:mm");
      link.setAttribute("download", `order_${date}.xml`);
      document.body.appendChild(link);
      link.click();
    });
  };

  return (
    <section className="ec-page-content ec-vendor-dashboard section-space-p">
      <div className="container">
        <div className="row">
          <Sidebar />
          <div className="ec-shop-rightside col-lg-9 col-md-12">
            <div className="ec-vendor-dashboard-card space-bottom-30">
              <div className="ec-vendor-card-header">
                <h5>Orders</h5>
              </div>
              <div className="ec-vendor-card-body">
                <div className="ec-vendor-card-table">
                  <table className="table ec-table">
                    <thead>
                      <tr>
                        <th scope="col">Order Number</th>
                        <th scope="col">Buyer Name</th>
                        <th scope="col">Submit Date</th>
                        <th scope="col">Download</th>
                      </tr>
                    </thead>
                    <tbody>
                      {response?.data.results.map((order: any) => (
                        <tr key={order.id}>
                          <th>
                            <Link to={`/admin/orders/${order.id}`}>
                              <span>
                                {" "}
                                #{" "}
                                {order.orderNumber.toString().padStart(5, "0")}
                              </span>
                            </Link>
                          </th>
                          <td>
                            <span>
                              {order.user.firstName} {order.user.lastName}
                            </span>
                          </td>
                          <td>
                            <span>
                              {moment(order.createdAt).format("YYYY-MM-DD")}
                            </span>
                          </td>
                          <td>
                            <span className="d-flex">
                              <button
                                className="btn btn-primary mr-2"
                                onClick={() => {
                                  handleDownloadExcel(order.id);
                                }}
                              >
                                Cart
                              </button>
                              <button
                                className="btn btn-primary"
                                onClick={() => {
                                  handleDownloadXML(order.id);
                                }}
                              >
                                XML
                              </button>
                            </span>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
                <div className="col-lg-12">
                  <ReactPaginate
                    nextLabel=">>"
                    onPageChange={handlePageChange}
                    pageRangeDisplayed={3}
                    marginPagesDisplayed={2}
                    pageCount={response?.data.totalPages}
                    forcePage={currentPage - 1}
                    previousLabel="<<"
                    pageClassName="page-item"
                    pageLinkClassName="page-link"
                    previousClassName="page-item"
                    previousLinkClassName="page-link"
                    nextClassName="page-item"
                    nextLinkClassName="page-link"
                    breakLabel="..."
                    breakClassName="page-item"
                    breakLinkClassName="page-link"
                    containerClassName="pagination"
                    activeClassName="active"
                    renderOnZeroPageCount={null}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
